import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { DsMenuItem } from 'design-system';
import { NewsletterService } from './services/newsletter.service';
import { DestroyComponent } from './components/destroy/destroy.component';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends DestroyComponent implements OnInit {
  isSidebarCollapsed = true;
  menuItems: DsMenuItem[] = [];
  loading: boolean;
  calendarTranslations = {
    dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
    dayNamesShort: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
    dayNamesMin: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
    monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
    monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
    today: "Dziś",
    clear: "Wyczyść",
    weekHeader: "Tydz."
  }

  constructor(private location: Location, @Inject(DOCUMENT) private document, private newsletterService: NewsletterService, private config: PrimeNGConfig) {
    super();
  }

  ngOnInit() {
    this.setMenuItems();
    this.newsletterService.initKonfiguracja();
    this.config.setTranslation(this.calendarTranslations);
  }

  setCollapseState() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  goBack() {
    this.location.back();
  }

  private setMenuItems(): void {
    this.menuItems = [
      {
        title: 'Strona Główna',
        url: environment.portalUrl,
        tooltip: 'Strona Główna',
        icon: 'pi pi-home'
      },
      {
        title: 'Pomoc',
        url: `${environment.portalUrl}/prs-pomoc`,
        tooltip: 'Pomoc',
        icon: 'pi pi-info-circle'
      },
    ];
  }
}
